// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a52224cb","598":"d2b8296b","703":"3042b9d8","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};